<template>
  <div class="main">
    <Header 
      :show="true"
      title="装车排队"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <div
        v-if="checkPermission([42])"
        style="padding: 20px 30px;"
      >
        <van-button 
          type="primary" 
          block 
          @click="dialogVisibleCreate = true"
        >
          新增
        </van-button>
      </div>
      
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{row}">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item
                v-if="checkPermission([43]) || checkPermission([44])"
                label="操作"
              >
                <el-button 
                  v-if="checkPermission([43])"
                  type="primary" 
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  插队
                </el-button>
                <el-button 
                  v-if="checkPermission([44])"
                  type="danger" 
                  size="mini"
                  @click="handleClickDelete(row)"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="60"
        >
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNumber"
          align="center"
        >
          <template slot-scope="{row}">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="司机"
          prop="driver"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.driver }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            <el-tag
              v-if="row.id === 1"
              type="success"
            >
              装车中
            </el-tag>
            <el-tag
              v-else-if="row.id === 2"
              type="success"
            >
              装车中
            </el-tag>
            <el-tag
              v-else
              type="warning"
            >
              等待中
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="height: 1rem; background-color: #FFFFFF;" />
      
      <van-dialog
        v-model="dialogVisibleCreate" 
        title="添加到排队队列"
        show-cancel-button
        :before-close="handleClickCreate"
      >
        <van-form>
          <van-field
            v-model.trim="listQuery.driver"
            label="司机姓名"
            placeholder="请输入司机姓名"
            required
          />
          <van-field
            v-model.trim="listQuery.plateNumber"
            label="车牌号"
            placeholder="请输入车牌号"
            required
            :rules="[{ validator: validCheckPlateNumber, message: '' }]"
          />
          <van-field
            ref="reason"
            v-model="listQuery.reason"
            rows="1"
            autosize
            label="原因"
            type="textarea"
            maxlength="100"
            placeholder="请输入添加原因"
            show-word-limit
            required
            :rules="[{ validator: validCheckRemark, message: '' }]"
          />
        </van-form>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isPlateNumber } from '@/utils/validate'
  import { getList, createOne, updateOne, deleteOne } from '@/api/queue.js'

  export default {
    name: "ServiceBussinessTruck",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        dialogVisibleCreate: false,
        listQuery: {
          limit: 10,
          page: 1,
          driver: '',
          plateNumber: '',
          remark: ''
        },
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          this.listQuery.page++
          if (this.listQuery.limit * (this.listQuery.page + 1) < this.table.total) {
            this.handleClickQuery()
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, '拉取装车排队记录', '没有新的数据')
          }
        }, 1000)
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              let status = '等待中'
              if (i === 0 || i === 1) {
                status = '装车中'
              }
              this.table.data.push({
                id: i + 1,
                serial: items[i].id,
                driver: items[i].driver,
                plateNumber: items[i].plateNumber,
                remark: items[i].remark,
                status: status
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      validCheckPlateNumber(value) {
        return new Promise((resolve) => {
          const result = isPlateNumber(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validCheckRemark(val) {
        if (val.replace(/(^\s*)|(\s*$)/g, "") === '') {
          return false
        } else {
          return true
        }
      },
      handleClickCreate(action, done) {
        if (action === 'confirm') {
          if ((this.listQuery.verify === 1) && (this.listQuery.reason === '')) {
            showPhoneAlarm(true, 'toast', null, 2000, 300, null, '请输入拒绝原因')
            done(false)
          } else if (this.listQuery.driver === '') {
            showPhoneAlarm(true, 'toast', null, 2000, 300, null, '请输入司机姓名')
            done(false)
          } else {
            const data = {
              driver: this.listQuery.driver,
              plateNumber: this.listQuery.plateNumber,
              remark: this.listQuery.remark
            }
            this.loading = true
            createOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '添加', data.message)) {
                this.handleClickQuery()
              }
              this.loading = false
              done(true)
            }).catch(function(error) {
              this.loading = false
              done(true)
              console.error(error)
            })
          }
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消添加')
          done(true)
        }
      },
      handleClickUpdate(row) {
        Dialog.confirm({
          title: '确认货车顺序插入到第三？',
          message: '货车车牌号：' + row.plateNumber,
          theme: 'round-button'
        }).then(() => {
          const data = {
            driver: row.driver,
            plateNumber: row.plateNumber,
            remark: ''
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '插队', data.message)) {
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '插队', '取消')
        })
      },
      handleClickDelete(row) {
        this.table.temp = row
        Dialog.confirm({
          title: '确认删除队列中的货车信息？',
          message: '货车车牌号：' + row.plateNumber,
          theme: 'round-button'
        }).then(() => {
          const data = {
            plateNumber: row.plateNumber
          }
          this.loading = true
          deleteOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除', data.message)) {
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '删除', '取消')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 25%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
